module.exports = __webpack_public_path__ + "static/media/ic_ProcessAssessment.e1c77a02.svg";